'use strict';

module.exports.AppContainer = require('./AppContainer');


//////////////////
// WEBPACK FOOTER
// ../~/react-hot-loader/lib/index.prod.js
// module id = 2092
// module chunks = 1